"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgPreviewDecorations = void 0;
// external
const React = require("react");
// local
const CircularIcon_1 = require("../../../CircularIcon");
// css
const imgPreviewStyles = require("../../styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(imgPreviewStyles, "imgPreview");
/**
 * Inserts a decoration inside the image preview
 *
 * @example use this toggle the colours on an image
 */
const ImgPreviewDecorations = ({ decorations }) => {
    return (React.createElement("div", { className: css("decorations") }, decorations.map(({ icon, onClick, variant }, i) => (React.createElement("span", { key: i, "data-test": `decoration-${i}` },
        React.createElement(CircularIcon_1.CircularIcon, { className: css("decorations_icon"), name: icon, onClick: onClick, variant: variant }))))));
};
exports.ImgPreviewDecorations = ImgPreviewDecorations;
//# sourceMappingURL=index.js.map